import type { Ref } from 'react';
import { forwardRef } from 'react';

import type { TIconSize } from '../../icon.interface';
const BillingInvalidExpirationDate = forwardRef(
  ({ ...props }: TIconSize, ref: Ref<SVGSVGElement>) => {
    return (
      <svg
        width="183"
        height="200"
        viewBox="0 0 183 200"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        ref={ref}
        {...props}
      >
        <path
          d="M162.492 35.8821C175.08 53.4071 181.887 70.8789 182.412 87.4395C183.001 104.002 177.324 119.705 169.828 135.891C162.33 152.024 152.958 168.637 140.374 170.834C127.79 172.978 111.991 160.758 94.7489 153.846C77.4448 146.984 58.709 145.484 47.0268 135.141C35.3596 124.744 30.8075 105.503 33.1644 86.7433C35.5744 67.9857 44.9997 49.7007 59.4578 32.5589C73.9712 15.3553 93.6237 -0.724166 112.581 0.0252024C131.591 0.7767 149.958 18.3549 162.492 35.8821Z"
          fill="#E8F0FF"
        />
        <path
          d="M93.8415 24.2927H2.2957C1.02775 24.2927 -0.00012207 25.427 -0.00012207 26.8263V131.335C-0.00012207 132.734 1.02775 133.869 2.2957 133.869H93.8415C95.1094 133.869 96.1373 132.734 96.1373 131.335V26.8263C96.1373 25.427 95.1094 24.2927 93.8415 24.2927Z"
          fill="#F9F9F9"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.2957 24.2927H93.8415C95.1094 24.2927 96.1373 25.3898 96.1373 26.7431V32.5626H-0.00012207V26.7431C-0.00012207 25.3898 1.02775 24.2927 2.2957 24.2927Z"
          fill="#B2B2B2"
        />
        <path
          d="M3.87469 29.7635C4.58834 29.7635 5.16686 29.185 5.16686 28.4714C5.16686 27.7577 4.58834 27.1792 3.87469 27.1792C3.16104 27.1792 2.58252 27.7577 2.58252 28.4714C2.58252 29.185 3.16104 29.7635 3.87469 29.7635Z"
          fill="#F9F9F9"
        />
        <path
          d="M7.31854 29.7635C8.03218 29.7635 8.61071 29.185 8.61071 28.4714C8.61071 27.7577 8.03218 27.1792 7.31854 27.1792C6.60489 27.1792 6.02637 27.7577 6.02637 28.4714C6.02637 29.185 6.60489 29.7635 7.31854 29.7635Z"
          fill="#F9F9F9"
        />
        <path
          d="M10.7621 29.7635C11.4758 29.7635 12.0543 29.185 12.0543 28.4714C12.0543 27.7577 11.4758 27.1792 10.7621 27.1792C10.0485 27.1792 9.46997 27.7577 9.46997 28.4714C9.46997 29.185 10.0485 29.7635 10.7621 29.7635Z"
          fill="#F9F9F9"
        />
        <path
          d="M87.6185 39.282H8.2699V64.702H87.6185V39.282Z"
          fill="#E8F0FF"
        />
        <path
          d="M21.2176 60.0692C25.8098 60.0692 29.5325 56.3464 29.5325 51.7542C29.5325 47.1619 25.8098 43.4392 21.2176 43.4392C16.6253 43.4392 12.9026 47.1619 12.9026 51.7542C12.9026 56.3464 16.6253 60.0692 21.2176 60.0692Z"
          fill="#E90200"
        />
        <path
          d="M24.4367 48.0689L17.5732 54.9323M17.946 48.0689L24.8094 54.9323"
          stroke="white"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M81.7981 43.9146H35.2343V46.7654H81.7981V43.9146Z"
          fill="#B2B2B2"
        />
        <path
          d="M50.9139 50.5669H35.2343V53.4177H50.9139V50.5669Z"
          fill="#B2B2B2"
        />
        <path
          d="M87.6185 70.4038H8.2699V95.8239H87.6185V70.4038Z"
          fill="#E8F0FF"
        />
        <path
          d="M21.2176 91.191C25.8098 91.191 29.5325 87.4682 29.5325 82.876C29.5325 78.2838 25.8098 74.561 21.2176 74.561C16.6253 74.561 12.9026 78.2838 12.9026 82.876C12.9026 87.4682 16.6253 91.191 21.2176 91.191Z"
          fill="#E90200"
        />
        <path
          d="M81.7981 75.0361H35.2343V77.887H81.7981V75.0361Z"
          fill="#B2B2B2"
        />
        <path
          d="M50.9139 81.6887H35.2343V84.5396H50.9139V81.6887Z"
          fill="#B2B2B2"
        />
        <path
          d="M24.4371 79.5313L17.5737 86.3947M17.9465 79.5313L24.8099 86.3947"
          stroke="white"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M87.6185 101.526H8.2699V126.946H87.6185V101.526Z"
          fill="#E8F0FF"
        />
        <path
          d="M21.2176 122.313C25.8098 122.313 29.5325 118.59 29.5325 113.998C29.5325 109.406 25.8098 105.683 21.2176 105.683C16.6253 105.683 12.9026 109.406 12.9026 113.998C12.9026 118.59 16.6253 122.313 21.2176 122.313Z"
          fill="#E90200"
        />
        <path
          d="M24.4367 110.61L17.5732 117.473M17.946 110.61L24.8094 117.473"
          stroke="white"
          strokeWidth="2"
          strokeMiterlimit="10"
        />
        <path
          d="M81.7981 106.158H35.2343V109.009H81.7981V106.158Z"
          fill="#B2B2B2"
        />
        <path
          d="M50.9139 112.81H35.2343V115.661H50.9139V112.81Z"
          fill="#B2B2B2"
        />
        <path
          d="M80.282 104.104C79.9771 105.171 75.0985 130.937 83.4836 154.872C84.8558 155.177 84.7033 151.366 84.7033 151.366L83.1787 118.587L83.941 106.238L80.282 104.104Z"
          fill="#FFB688"
        />
        <path
          d="M103.151 200H88.3624C88.3624 200 83.3313 148.012 83.3313 146.945C84.246 147.859 84.0936 148.164 87.905 149.231C90.1919 151.671 106.352 192.225 106.352 192.225L103.151 200Z"
          fill="#065BDC"
        />
        <path
          d="M95.8038 84.7418C102.928 86.7802 97.3025 108.542 94.665 110.365C92.0274 112.189 79.6631 107.057 78.666 104.749C77.669 102.441 85.7172 81.8558 95.8038 84.7418Z"
          fill="#0F3893"
        />
        <path
          d="M102.236 78.9487C124.952 78.9487 125.409 144.201 122.208 146.945C119.006 149.689 86.2278 152.281 83.3311 146.945C80.4344 141.609 77.5377 78.9487 102.236 78.9487Z"
          fill="#0F3893"
        />
        <rect
          x="89.4182"
          y="90.4517"
          width="19.9956"
          height="13.747"
          rx="1.86896"
          transform="rotate(59.8572 89.4182 90.4517)"
          fill="#065BDC"
        />
        <rect
          x="86.9327"
          y="91.8943"
          width="19.9956"
          height="2.2495"
          transform="rotate(59.8572 86.9327 91.8943)"
          fill="#AECCFF"
        />
        <rect
          x="84.6865"
          y="96.6672"
          width="6.99845"
          height="0.874807"
          transform="rotate(59.8572 84.6865 96.6672)"
          fill="#AECCFF"
        />
        <path
          d="M110.469 83.3698C116.415 78.9485 130.288 96.6336 130.136 99.8352C129.983 103.037 118.397 109.745 115.957 109.135C113.518 108.525 102.05 89.6297 110.469 83.3698Z"
          fill="#0F3893"
        />
        <path
          d="M128.001 100.445C133.642 109.745 135.167 122.094 135.167 124.228C135.167 130.022 132.27 132.919 130.441 132.919C123.123 132.919 99.0344 114.319 97.3574 112.794C95.6804 111.27 100.559 106.696 101.321 107.458C102.084 108.22 110.774 113.709 123.428 119.197C121.598 116.91 116.262 110.05 116.11 107.915C115.957 105.781 128.001 100.445 128.001 100.445Z"
          fill="#FFB688"
        />
        <path
          d="M106.2 81.8452C106.2 83.8271 98.272 83.9796 98.272 81.8452V69.801H106.2V81.8452Z"
          fill="#DB9D76"
        />
        <path
          d="M100.178 76.9666C104.514 76.9666 108.03 70.7211 108.03 63.0168C108.03 55.3125 104.514 49.0669 100.178 49.0669C95.8417 49.0669 92.3264 55.3125 92.3264 63.0168C92.3264 70.7211 95.8417 76.9666 100.178 76.9666Z"
          fill="#FFB688"
        />
        <path
          d="M107.496 67.0568C108.632 67.0568 109.554 66.1353 109.554 64.9986C109.554 63.8619 108.632 62.9404 107.496 62.9404C106.359 62.9404 105.437 63.8619 105.437 64.9986C105.437 66.1353 106.359 67.0568 107.496 67.0568Z"
          fill="#FFB688"
        />
        <path
          d="M134.252 47.0849C128.306 47.0849 123.428 51.3537 117.024 51.3537C112.451 51.3537 108.029 45.8652 101.626 45.8652C93.3934 45.8652 90.8016 50.2865 90.8016 53.3357C90.8016 55.775 92.3262 58.5192 92.7836 58.5192C92.7836 57.7569 93.6983 55.0127 94.0032 54.7078C94.3082 55.775 100.711 63.2454 106.352 63.2454V63.2881C106.662 63.0808 107.023 62.9615 107.395 62.943C107.767 62.9245 108.138 63.0076 108.467 63.1832C108.795 63.3588 109.07 63.6205 109.262 63.9403C109.454 64.26 109.555 64.6258 109.555 64.9987C109.555 65.3715 109.454 65.7373 109.262 66.0571C109.07 66.3768 108.795 66.6385 108.467 66.8141C108.138 66.9898 107.767 67.0728 107.395 67.0543C107.023 67.0358 106.662 66.9166 106.352 66.7092V71.1732H107.877C109.859 71.1732 110.774 70.4109 113.823 70.4109C119.159 70.4109 126.629 76.9666 135.777 76.9666C145.686 76.9666 149.803 69.4962 149.803 61.111C149.803 49.9816 139.283 47.0849 134.252 47.0849Z"
          fill="#0B0B0B"
        />
        <path
          d="M122.208 146.945V200H103.151L87.8867 149.196C93.241 150.146 113.518 150.908 122.208 146.945Z"
          fill="#74AAFF"
        />
        <path
          d="M101.013 110.927C102.15 108.958 100.854 106.082 98.1198 104.504C95.3853 102.925 92.2471 103.241 91.1104 105.21C89.9737 107.179 91.269 110.054 94.0035 111.633C96.7379 113.212 99.8761 112.896 101.013 110.927Z"
          fill="#FFB688"
        />
      </svg>
    );
  }
);
export default BillingInvalidExpirationDate;
